<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header> 
                
        <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Filtros
            </b-card-header>
            <b-card-body>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-6">
                        <label>Fecha desde</label><br/>   
                        <datetime v-model="model.desde" input-class="form-control" type="datetime"></datetime>
                    </div>
                    <div class="col-md-6">
                        <label>Fecha hasta</label><br/>   
                        <datetime v-model="model.hasta" input-class="form-control" type="datetime"></datetime>
                    </div>
                    <div class="col-md-6">   
                        <label>Estado</label><br/>                            
                        <KitsCombo v-model="model.estado" v-bind:items=estados propertyName='Name' propertyID="EntityID" todos='true'></KitsCombo> 
                    </div>
                </div>   
                <div class="row">
                    <div class="col-md-12 text-right">
                        <filter-button @click="filtrar"></filter-button>
                    </div>
                </div>
            </b-card-body>
        </b-card>  

        <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Movimientos
            </b-card-header>
            <b-card-body>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-12">
                        <download-csv
                            v-if="movimientos.length > 0"
                            class   = "btn btn-success"
                            :data   = "movimientos"
                            :fields = "csv.json_fields"
                            :labels = "csv.labels"
                            :name    = "exportFileName"
                            delimiter = ";">
                            <i class="fa fa-fw fa-file-excel"></i>Exportar
                            
                        
                        </download-csv>
                        <b-table striped hover :items="movimientos" :fields="campos" class="mt-3" outlined>
                            <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong> 
                            </div>
                        </b-table>
                    </div>
                </div>   
            </b-card-body>
        </b-card>            
    </div>
</template>

<style>
</style>

<script>

    // ******************** Select ********************//
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    // ******************** Select ********************//

    import axiosHelpers from '@/helpers/axiosHelpers';
    import datetimeHelpers from '@/helpers/datetimeHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    import KitsCombo from '@/components/KitsCombo';

    import DateTime from 'luxon/src/datetime.js'

    import JsonCSV from 'vue-json-csv' 
    Vue.component('downloadCsv', JsonCSV)
    
    export default{
        components: { KitsCombo },
        data(){
            return{
                procesando: false,
                nombrearchivo: 'Mis Pagos Recibidos.csv',
                movimientos: [],
                campos: [
                    { key: 'FormatedReceipt', label: 'Comprobante', sortable: true, sortDirection: 'desc' },
                    { key: 'FormatedAmount', label: 'Importe', sortable: true, sortDirection: 'desc' },
                    { key: 'Aux', label: 'Referencia', sortable: true, sortDirection: 'desc' },
                    { key: 'FormatedDate', label: 'Fecha', sortable: true, sortDirection: 'desc' },
                    { key: 'State', label: 'Estado', sortable: true, sortDirection: 'desc' },
                ],
                estados:[],
                model: {
                    desde: datetimeHelpers.getMonthStart(),
                    hasta: datetimeHelpers.getNextDay(),
                    estado: null
                },
                csv: {
                    json_fields: [
                        'FormatedReceipt',
                        'FormatedAmount',
                        'Aux',
                        'FormatedDate',
                        'State',
                    ],
                    labels: {
                        FormatedReceipt: 'Comprobante',
                        FormatedAmount: 'Importe',
                        Aux: 'Referencia',
                        FormatedDate: 'Fecha',
                        State: 'Estado',
                    },
                    json_meta: [
                        [
                            {
                                'key': 'charset',
                                'value': 'utf-8'
                            }
                        ]
                    ]
                },
            }
        },
        computed: {
            // a computed getter
            exportFileName: function () {
                var d = new Date();
                var datestring = datetimeHelpers.getFormattedDDMMYYYY(d, '');
                var temp = 'Mis Pagos Recibidos' + datestring + '.csv'; 

                return temp;
            }
        },
        methods: {
            filtrar(){
                if(datetimeHelpers.compareFromTo(this.model.desde, this.model.hasta)){
                    notificationHelpers.showWarning('Advertencia!', 'La fecha hasta debe ser superior a la fecha desde', this);
                    return;
                }

                if(datetimeHelpers.compareDifference(this.model.desde, this.model.hasta, 62)){
                    notificationHelpers.showWarning('Advertencia!', 'El rango de fechas ingresado no puede superar los 2 meses', this);
                    return;
                }


                let req = { DateFrom: this.model.desde, DateTo: this.model.hasta, StateID: this.model.estado};

                let context = this;

                axiosHelpers.axiosGet('Supplier/GetSupplierPaymentsReceived', req, this, function(data){ 
                    context.movimientos = data.ResponseVM;
                });


                console.log(req);
            }
        },
        beforeMount: function(){
            let context = this;
            axiosHelpers.axiosGet('Supplier/GetNotificationStates', {}, this, function(data){ 
                context.estados = data.ResponseVM;
            });
        }
    }
</script>